import { useState } from "react";
import { Transition } from "@headlessui/react";
import { ChevronDown } from "react-bootstrap-icons";

export default function Collapse({ children, header }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="mb-3">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center justify-between w-full py-2 rounded-lg"
      >
        <span className="text-sm font-medium">{header}</span>
        <ChevronDown
          className={`w-5 h-5 transition-transform ${isOpen ? "rotate-180" : "rotate-0"
            }`}
        />
      </button>

      <Transition
        show={isOpen}
        enter="transition-all duration-300 ease-out"
        enterFrom="opacity-0 max-h-0"
        enterTo="opacity-100 max-h-[500px]"
        leave="transition-all duration-200 ease-in"
        leaveFrom="opacity-100 max-h-[500px]"
        leaveTo="opacity-0 max-h-0"
      >
        <div className="mt-2 overflow-hidden bg-white ">
          <p className="text-zinc-700 text-sm">
            {children}
          </p>
        </div>
      </Transition>
    </div>
  );
}
